/*******************************************************************
* PAGE        : localDataStorage
* REMARKS     : Comman localData Storage
* CREATED ON  : 11-11-2025
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 04-02-2026
********************************************************************/

import CryptoJS from 'crypto-js';

// Secret key for encryption (should be stored securely, not in code)
const secretKey = 'MySecretKey@123';  // In production, use a more secure way to handle this key!

// Encrypt and store all data as a single object in localStorage
const setLocalStorage = (key, value) => {
    // Retrieve the current object from localStorage (if it exists)
    let currentData = getLocalStorage() || {};

    // Update the object with the new key-value pair
    currentData[key] = value;

    // Encrypt the updated object and store it back in localStorage
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(currentData), secretKey).toString();
    localStorage.setItem('CMExpressData', encryptedData);  // Store as one entry in localStorage    
};

// Decrypt and retrieve the value for a specific key from localStorage
const getLocalStorage = (key = null) => {
    // Retrieve the encrypted object from localStorage
    const encryptedData = localStorage.getItem('CMExpressData');

    if (encryptedData) {
        // Decrypt the data
        const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
        // Convert the decrypted data back to a JavaScript object
        const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

        // If a key is provided, return the value of that key; otherwise, return the whole object
        if (key) {
            return decryptedData[key] || null;  // Return null if the key doesn't exist
        }
        return decryptedData;  // Return the entire object if no key is specified
    } else {
        return null; // Return null if the item doesn't exist in localStorage
    }
};

// Remove the encrypted data from localStorage
const removeLocalStorage = () => {
    localStorage.removeItem('CMExpressData');
};

const localDataStorage = {
    setLocalStorage: setLocalStorage,
    getLocalStorage: getLocalStorage,
    removeLocalStorage: removeLocalStorage
};

export default localDataStorage;
